import { Component, OnInit, ViewChild, ElementRef, ChangeDetectionStrategy, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { OnlineApplicationService } from '../services/online-application.service'
import { FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/core/ui/notification/toast.service';
import { Title, Meta } from '@angular/platform-browser';
import { ResponsiveService } from 'src/app/core/ui/responsive/responsive.service';

@Component({
  selector: 'app-online-application-confirmation',
  templateUrl: './online-application-confirmation.component.html',
  styleUrls: ['./online-application-confirmation.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OnlineApplicationConfirmationComponent implements OnInit {
  @ViewChild('dangerTpl') dangerTpl: TemplateRef<any> | undefined;
  @ViewChild('paypalform') paypalform: ElementRef | undefined;
  @ViewChild('securityToken') secureToken: ElementRef | any;
  @ViewChild('securityId') secureId: ElementRef | any;
  // secureToken : any
  // secureId : any
  constructor(
    protected activatedRoute: ActivatedRoute, public router: Router, private onlineApplicationService: OnlineApplicationService,
    private OnlineApplicationService: OnlineApplicationService,
    private modalService: NgbModal,
    private toastService: ToastService,
    protected titleService: Title,
    private metaService: Meta,
    private responsiveService: ResponsiveService
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('Michigan Property Management | Rental Property Management Company in Michigan');
    this.metaService.updateTag(
      { name: 'keywords', content: `Property Management Company, Rental Property Management, Property Management Services` }
    );
    this.metaService.updateTag(
      { name: 'description', content: `Michigan Based North Bloomfield Properties Management Company offers Rental Property Management Services for Property Owners and Tenants in the Michigan area.` }
    );
    const win = this.responsiveService.getWindow()
    if (win) {
      if (win.history.state.data) {
        const formVal = win.history.state.data
        this.confirmationform.controls['name'].setValue(formVal.fname);
        this.confirmationform.controls['Lname'].setValue(formVal.lname);
        this.confirmationform.controls['state'].setValue(formVal.state);
        this.confirmationform.controls['city'].setValue(formVal.city);
        this.confirmationform.controls['zip'].setValue(formVal.zip);
        this.confirmationform.controls['email'].setValue(formVal.email);
        this.confirmationform.controls['phone'].setValue(formVal.phone);
        this.confirmationform.controls['Address'].setValue(formVal.address);
        this.confirmationform.controls['is_co_applicant'].setValue(formVal.is_co_applicant);
        this.applicationInfo = {
          property_id: formVal.property_id,
          applicant_id: formVal.applicant_id,
          application_id: formVal.application_id
        }
      }
    }

  }
  applicationInfo: any;
  confirmationform: FormGroup = this.OnlineApplicationService.getconfirmationform();
  onlineconfirmation() {
    if (this.confirmationform.valid) {
      const payload = {...this.confirmationform.value,...this.applicationInfo}
      // console.log(payload)
      this.onlineApplicationService.getPaypalToken(payload).toPromise().then((result) => {
        // this.secureToken = result.body.data.SECURETOKEN;
        // this.secureId = result.body.data.SECURETOKENID;
        if (this.secureToken) {
          this.secureToken.nativeElement.value = result.body.data.SECURETOKEN
        }
        if (this.secureId) {
          this.secureId.nativeElement.value = result.body.data.SECURETOKENID
        }
        // console.log(result.body.data.SECURETOKEN)
        // console.log(result.body.data.SECURETOKENID)
        // if (this.paypalform) {
        //   // console.log(this.paypalform.nativeElement.value)
        //   // console.log(this.secureId.nativeElement.value)
        //   // console.log(this.secureToken.nativeElement.value)
          
        // }
        // alert(this.paypalform)
        this.paypalform?.nativeElement.submit();
      })
    } else {
      // this.showDanger();
      this.confirmationform.markAllAsTouched();
      const keys = Object.keys(this.confirmationform.controls);
      for (const key of keys) {
        this.confirmationform.get(key)?.markAsDirty();
      }
    }
  }

  showSuccess() {
    this.toastService.show('Operation Successful', {
      classname: 'bg-success text-light',
      delay: 10000,
    });
  }

  showDanger() {
    if (!this.dangerTpl) return;
    this.toastService.show(this.dangerTpl, {
      classname: 'bg-danger text-light',
      delay: 15000,
    });
  }
  // secureToken:string | undefined;
  // secureId:string | undefined;

}

